import styled from 'styled-components';

export const StartedHashtags = styled.p`
  margin: 10px 0;
  font-size: 0.9em;
  font-weight: 400;
  color: gray;
`;
